var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0M5.038 6.095S5 6.5 5.5 6.5c.558-1.071 1.269-.913 1.269-.913C6 8.5 5.442 8.5 5 9.5c0 1.37.834 1.489.979 1.499L6 11c1.5 0 2.537-1.81 2.537-1.81 0-.378 0-.69-.537-.19l-.696.19c-.804.31-.535-.345-.535-.345S7.86 7.5 8.189 6.192c0 0 .348-1.192-.978-1.423C6 4.5 5.14 5.939 5.038 6.095M8.65 3h-.03c-1.054.11-.963.987-.963.987-.068.855.787.817.787.817.9-.07.973-.76.977-.911v-.03c0-.798-.624-.86-.77-.863"
})));
export default SvgInfo;